/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import $ from 'jquery';
import React from 'react';
import isEqual from 'react-fast-compare';

import DataConnector from 'connect/DataConnector';
import ProteinActions from 'molbio/proteins/ProteinActions';
import ProteinStore, {SearchResult} from 'molbio/proteins/ProteinStore';
import FullScreenStore from 'nav/full-screen/FullScreenStore';
import SidepanelStore from 'nav/sidepanel/SidepanelStore';
import CtrlFView from 'ui-library/CtrlFView';
import * as keyboard from 'util/Keyboard';

const PROTEIN_SEARCH_EVENT_NAMESPACE = 'protein-ctrl-f-view';

class ProteinCtrlFViewConnector extends DataConnector<ProteinCtrlFViewProps, EnhancedProps> {
  shouldSubscribeToRedux = false;
  stores = [ProteinStore, SidepanelStore, FullScreenStore];

  enhanceProps(): EnhancedProps {
    return {
      selectedIndex: this.proteinStore().getSelectedSearchResultIndex(),
      selectedSearchResult: this.proteinStore().getSelectedSearchResult(),
      numSearchResults: this.proteinStore().getNumSearchResults(),
      pendingOpenSearchView: this.proteinStore().getPendingOpenSearchView(),
      sidepanelIsExpanded: this.sidepanelStore().getIsExpanded(),
      fullScreenPageRendered: this.fullScreenStore().getCurrentScreen() != null,
    };
  }
}

interface ProteinCtrlFViewProps {
  jumpToIndex: (index: number) => void;
}
interface EnhancedProps {
  selectedIndex: number;
  selectedSearchResult: SearchResult | undefined;
  numSearchResults: number;
  pendingOpenSearchView: boolean;
  sidepanelIsExpanded: boolean;
  fullScreenPageRendered: boolean;
}

interface ProteinCtrlFViewState {
  query: string;
  visible: boolean;
}

class ProteinCtrlFView extends React.Component<ProteinCtrlFViewProps & EnhancedProps, ProteinCtrlFViewState> {
  state: ProteinCtrlFViewState = {
    query: '',
    visible: false,
  };

  searchRef = React.createRef<CtrlFView>();

  componentDidMount(): void {
    $(window).on(`keydown.${PROTEIN_SEARCH_EVENT_NAMESPACE}`, (e) => {
      if (keyboard.isCtrlF(e)) {
        if (this.props.sidepanelIsExpanded || this.props.fullScreenPageRendered) {
          return;
        }

        e.preventDefault();
        this._handleOpenSearchView();
      }
    });
  }

  componentDidUpdate(
    prevProps: ProteinCtrlFViewProps & EnhancedProps,
    prevState: ProteinCtrlFViewState
  ): void {
    if (!prevState.visible && this.state.visible) {
      this._handleQueryChange(this.state.query);
    }

    const selectedSearchResultChanged = !isEqual(
      prevProps.selectedSearchResult,
      this.props.selectedSearchResult
    );
    if (this.props.selectedSearchResult != null && selectedSearchResultChanged) {
      this.props.jumpToIndex(this.props.selectedSearchResult.index);
    }
    if (this.props.pendingOpenSearchView) {
      this._handleOpenSearchView();
      ProteinActions.completeOpenSearchView();
    }
  }

  componentWillUnmount(): void {
    $(window).off(`keydown.${PROTEIN_SEARCH_EVENT_NAMESPACE}`);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _handleOpenSearchView = () => {
    if (this.state.visible) {
      this.searchRef.current!.focusAndSelect();
    } else {
      this.show();
    }
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _handleQueryChange = (query: any) => {
    if (query.length === 0) {
      ProteinActions.clearSearchResults();
    } else {
      ProteinActions.searchAminoAcids(query);
    }
    this.setState({query});
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _handleViewNextResult = () => {
    ProteinActions.viewNextSearchResult();
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _handleViewPreviousResult = () => {
    ProteinActions.viewPreviousSearchResult();
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  hide = () => {
    ProteinActions.clearSearchResults();
    this.setState({visible: false});
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _handleClose = () => {
    this.hide();
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  show = () => {
    this.setState({visible: true});
  };

  render(): JSX.Element | null {
    if (!this.state.visible || this.props.sidepanelIsExpanded) {
      return null;
    }
    return (
      <CtrlFView
        ref={this.searchRef}
        onClose={this._handleClose}
        onQueryChange={this._handleQueryChange}
        query={this.state.query}
        onViewNextResult={this._handleViewNextResult}
        onViewPreviousResult={this._handleViewPreviousResult}
        selectedIndex={this.props.selectedIndex}
        numSearchResults={this.props.numSearchResults}
      />
    );
  }
}

export default ProteinCtrlFViewConnector.connect(ProteinCtrlFView);
